import React,{useState} from  'react'
import {AppDate} from 'qcc'
import { appDate } from 'utils';
import { Moment } from 'moment'

interface AppDateRangeProps {
    format?:string
    min?:string
    max?:string
	onChange?: (min?:string,max?:string) => void
}

export const AppDateRange = (props:AppDateRangeProps) =>{

    const[min ,setMin] = useState(appDate.moment(props.min))
    const[max, setMax] = useState(appDate.moment(props.max))

    const hanldMinChange = (newValue: Moment, returnValue: string) =>{
       setMin(newValue)
       props.onChange && props.onChange(appDate.string(newValue),appDate.string(max));
    }

    const hanldMaxChange = (newValue: Moment, returnValue: string) =>{
        setMax(newValue)
        props.onChange && props.onChange(appDate.string(min),appDate.string(newValue));
     }


    const handleAllChecked = () =>{
        if(min===null && max===null) return;
        setMin(null);
        setMax(null);
        props.onChange && props.onChange('','');
    }

    let allChecked = (min===null && max===null);

    return ( 
    <div className='app-search-item-container'>
        <div className='app-search-item-left'>
            <div className='app-search-all-content'>
                <span className='app-all-option' 
					data-checked={allChecked} 
					onClick={handleAllChecked}>全部
					<i className="qcciconfont-select app-all-option-checked-icon" 
					hidden={!allChecked} />
				</span>
            </div>
        </div>
        <div className='app-search-item-right'>
            <div className='app-search-date-range-container'>
                <span className='date-range-item'>
                    <AppDate size='small' 
                             onChange={hanldMinChange} 
                             value={appDate.string(min)}
                             key={appDate.string(min)}
                    />
                </span>
                <span className='date-range-item-split'>-</span>
                <span className='date-range-item'>
                    <AppDate size='small' 
                             onChange={hanldMaxChange} 
                             value={appDate.string(max)}
                             key={appDate.string(max)}
                    />
                </span>
               
            </div>
        </div>
    </div>)
}


// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/AppDateRange.tsx